export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  volunteer_required_for: {
    type: "string",
    required: true,
    title: "Volunteer Required For",
    inputType: "text",
  },
  date: {
    type: "string",
    required: true,
    title: "Date",
    inputType: "date",
  },
  duration: {
    type: "string",
    required: true,
    title: "Duration",
    inputType: "text",
  },
  location_of_volunteering: {
    type: "string",
    required: true,
    title: "Location of Volunteering",
    inputType: "text",
  },

  notes: {
    type: "text",
    required: false,
    title: "notes (If Any)",
  },
};
export const initialValues = {
  volunteer_required_for: "",
  date: "",
  duration: "",
  location_of_volunteering: "",
  notes: "",
};

export const view_all_table = [
  { name: "Required For", value: "volunteer_required_for" },
  { name: "Date", value: "date" },
  { name: "Duration", value: "duration" },
  { name: "Location Of Volunteering", value: "location_of_volunteering" },
];
